// extracted by mini-css-extract-plugin
module.exports = {"team-text":"Team_team-text__2gyxN"};